export default __webpack_public_path__ + "static/media/897.ac669ed4.png";